import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineRemoveDoubleCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14"
    {...props}
  >
    <g
      stroke="#616161"
      strokeLinecap="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path
        strokeLinejoin="round"
        d="m1.028 9.297 2.205 1.837m6.983-8.268L7.097 7.098M3.784 9.297l2.007 1.672a.92.92 0 0 0 1.328-.16l.467-.635m5.386-7.308L8.684 8.685"
      />
      <path d="m1.028 1.028 11.944 11.944" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineRemoveDoubleCheck;
